import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import { useData } from '../context/DataContext';
import './Footer.css';

export default function Footer() {
  const { companyInfo } = useData();
  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,0 L0,0 Z" fill="#FAF8F2"/>
        </svg>
      </div>
      <div className="footer-body container">
        <div className="footer-brand">
          <img src={logo} alt="OM Cares" className="footer-logo" />
          <p className="footer-tagline">"{companyInfo.tagline}"</p>
          <p className="footer-desc">ISO 9001:2015 certified manufacturer of medical-grade rubber & silicone products. Trusted by healthcare professionals across India.</p>
          <div className="footer-certs">
            {companyInfo.certifications.map(c => (
              <span key={c} className="cert-badge">{c}</span>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/products">Our Products</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/contact">Get a Quote</Link>
        </div>

        <div className="footer-col">
          <h4>Product Lines</h4>
          <Link to="/products">MedCore — Clinical</Link>
          <Link to="/products">Life-Assist — Home Care</Link>
          <Link to="/products">NeoCare — Mother & Baby</Link>
          <Link to="/products">MotionPro — Plastic Supplies</Link>
          <Link to="/products">SafeServe — Food Grade</Link>
          <Link to="/products">Athlete Support — Sports</Link>
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <a href={`mailto:${companyInfo.email}`}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
            {companyInfo.email}
          </a>
          <a href={`tel:${companyInfo.phone1.replace(/\s/g,'')}`}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.49 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.4 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.7A16 16 0 0 0 15.3 16.1l.8-.8a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            {companyInfo.phone1}
          </a>
          <a href={`tel:${companyInfo.phone2.replace(/\s/g,'')}`}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.49 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.4 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.7A16 16 0 0 0 15.3 16.1l.8-.8a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            {companyInfo.phone2}
          </a>
          <span className="footer-address">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
            {companyInfo.address}
          </span>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} OM Cares. All rights reserved. | ISO 9001:2015 Certified</p>
          <p>Made with care in India 🇮🇳</p>
        </div>
      </div>
    </footer>
  );
}
